// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerAddressAutocompleteWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { MultibrandAddressAutocompleteResponseDto } from '../..';

interface AutocompleteParams {
  partialAddress: string;
}

export const RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path =
  '/api/web/v1/properties/addresses/autocomplete';

/**
 * Get autocomplete addresses for a partial address
 */
export const RentalManagerAddressAutocompleteWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<AutocompleteParams, never, MultibrandAddressAutocompleteResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
